import React, { ReactElement } from 'react'
import { History } from 'history'
import { CaretRightOutlined } from '@ant-design/icons'
import { CaseSchema } from '@src/components/Schema/CaseSchema'
import style from './Index.module.less'
import { filterEmptyText } from '@js/tool'

interface Props {
  caseDetail: CaseSchema
  history: History
}

function Main ({ caseDetail, history }: Props): ReactElement {
  return (
    <div className={style.container}>
      <div className={style.block} onClick={() => history.push(`/case-edit/${caseDetail.id}/statement`)}>
        <div className={style['block-left']}>
          <div className={style['block-left-title']}>事实与理由</div>
          <div className={style['block-left-content']}>{filterEmptyText(caseDetail.claim.statement)}</div>
        </div>
        <div className={style['block-right']}>
          <CaretRightOutlined />
        </div>
      </div>
    </div>
  )
}

export default Main
